import Link from 'next/link';
import React from 'react';

export function JobListingsAll({jobs}) {
  return (
    <div className='py-8 px-4'>
      <div className='text-center'>
        <h1 className='text-4xl font-medium uppercase'>Career Opportunities</h1>
        <p className='text-xl mt-8 mb-4'>
          Here at Skar Audio we are looking for people who thrive on success and are passionate
          about building a business as well as their career. We work as a real team and have the
          success to prove it! Our company has been recognized as one of the fastest-growing
          businesses in America.
        </p>
      </div>

      <div
        style={{
          paddingTop: '17px',
          marginLeft: '11px'
        }}>
        <span className='font-medium text-black text-4xl md:text-2xl mt-6 font-oswald uppercase'>
          Open Positions ({jobs.length})
        </span>
      </div>

      <div className='mt-8 p-4 grid gap-6'>
        {jobs?.map((item, index) => {
          return <JobPostingPreview key={index} index={index} item={item} />;
        })}
      </div>
    </div>
  );
}

export function JobPostingPreview({index, item}) {
  return (
    <div key={item.id} className='bg-gray-50 hover:bg-gray-100 shadow rounded p-5'>
      <Link href={`/jobs/${item.id}`}>
        <div className='text-gray-500'>
          <h3 className='text-2xl font-semibold'>{item?.job_template?.job_title}</h3>
          <div className='flex mt-4 gap-6 flex-wrap items-center'>
            <div className='flex items-center gap-2'>
              <img
                height={20}
                width={20}
                src='/image/icons/svg-icons/JobRelated/location.svg'
                alt='Location Icon'
                role='presentation'
              />
              <span>
                <JobLocation item={item} />
              </span>
            </div>
            <div className='flex items-center gap-2'>
              <img
                height={20}
                width={20}
                src='/image/icons/svg-icons/JobRelated/department.svg'
                alt='Department Icon'
                role='presentation'
              />
              <span>{item?.job_template?.job_department}</span>
            </div>
            <div className='flex items-center gap-2'>
              <img
                height={20}
                width={20}
                src='/image/icons/svg-icons/JobRelated/compensation.svg'
                alt='Compensation Icon'
                role='presentation'
              />
              <span>
                <JobTiming item={item} />
              </span>
            </div>
          </div>
        </div>
      </Link>
      {/*{index !== jobs.length - 1 && <div className="border-t my-10"/>}*/}
    </div>
  );
}

export function JobTiming({item}) {
  let partTimeMap = {
    PART_TYPE: 'Part Time',
    FULL_TIME: 'Full Time'
  };
  let partTimeOrFullTime = partTimeMap[item?.job_template?.part_time_or_full_time];
  return partTimeOrFullTime;
}

export function JobLocation({item}) {
  let locationMap = {
    TPA: 'Tampa, FL',
    LV: 'Las Vegas, NV'
  };
  let locationName = locationMap[item?.job_template?.job_location];
  return locationName;
}
